export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_Whats.31c8f57d.png";